import hi from '@/assets/sounds/metronome/Perc_MetronomeQuartz_hi.mp3';
import mi from '@/assets/sounds/metronome/Perc_MetronomeQuartz_mi.mp3';
import lo from '@/assets/sounds/metronome/Perc_MetronomeQuartz_lo.mp3';
import C from '@/assets/sounds/chords/C.mp3';
import Cm from '@/assets/sounds/chords/Cm.mp3';
import C7 from '@/assets/sounds/chords/C7.mp3';
import CS from '@/assets/sounds/chords/CS.mp3';
import CSm from '@/assets/sounds/chords/CSm.mp3';
import CS7 from '@/assets/sounds/chords/CS7.mp3';
import D from '@/assets/sounds/chords/D.mp3';
import Dm from '@/assets/sounds/chords/Dm.mp3';
import D7 from '@/assets/sounds/chords/D7.mp3';
import Eb from '@/assets/sounds/chords/Eb.mp3';
import Ebm from '@/assets/sounds/chords/Ebm.mp3';
import Eb7 from '@/assets/sounds/chords/Eb7.mp3';
import E from '@/assets/sounds/chords/E.mp3';
import Em from '@/assets/sounds/chords/Em.mp3';
import E7 from '@/assets/sounds/chords/E7.mp3';
import F from '@/assets/sounds/chords/F.mp3';
import Fm from '@/assets/sounds/chords/Fm.mp3';
import F7 from '@/assets/sounds/chords/F7.mp3';
import FS from '@/assets/sounds/chords/FS.mp3';
import FSm from '@/assets/sounds/chords/FSm.mp3';
import FS7 from '@/assets/sounds/chords/FS7.mp3';
import G from '@/assets/sounds/chords/G.mp3';
import Gm from '@/assets/sounds/chords/Gm.mp3';
import G7 from '@/assets/sounds/chords/G7.mp3';
import GS from '@/assets/sounds/chords/GS.mp3';
import GSm from '@/assets/sounds/chords/GSm.mp3';
import GS7 from '@/assets/sounds/chords/GS7.mp3';
import A from '@/assets/sounds/chords/A.mp3';
import Am from '@/assets/sounds/chords/Am.mp3';
import A7 from '@/assets/sounds/chords/A7.mp3';
import Bb from '@/assets/sounds/chords/Bb.mp3';
import Bbm from '@/assets/sounds/chords/Bbm.mp3';
import Bb7 from '@/assets/sounds/chords/Bb7.mp3';
import B from '@/assets/sounds/chords/B.mp3';
import Bm from '@/assets/sounds/chords/Bm.mp3';
import B7 from '@/assets/sounds/chords/B7.mp3';

export const SAMPLES = {
  none: '',
  hi,
  lo,
  mi,
  C,
  Cm,
  C7,
  CS,
  CSm,
  CS7,
  D,
  Dm,
  D7,
  Eb,
  Ebm,
  Eb7,
  E,
  Em,
  E7,
  F,
  Fm,
  F7,
  FS,
  FSm,
  FS7,
  G,
  Gm,
  G7,
  GS,
  GSm,
  GS7,
  A,
  Am,
  A7,
  Bb,
  Bbm,
  Bb7,
  B,
  Bm,
  B7,
};
